import { render, staticRenderFns } from "./WaterUsage.vue?vue&type=template&id=b95c084c&lang=html"
import script from "./WaterUsage.vue?vue&type=script&lang=js"
export * from "./WaterUsage.vue?vue&type=script&lang=js"
import style0 from "./WaterUsage.vue?vue&type=style&index=0&id=b95c084c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports